import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_FHIRQuery, PermissionKeys_FHIRManager } from '@app/fhir-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { PermissionKey_FE } from '@nu-art/permissions-frontend';
export const dispatch_onFHIRQueriesUpdated = new ThunderDispatcherV3('__onFHIRQueriesUpdated');
export class ModuleFE_FHIRQuery_Class extends ModuleFE_BaseApi {
    permissions;
    constructor() {
        super(DBDef_FHIRQuery, dispatch_onFHIRQueriesUpdated);
        this.permissions = PermissionKey_FE.generatePermissionKeysByLevels(PermissionKeys_FHIRManager);
    }
    // ######################## Search ########################
    __searchFilterMapper = (item) => {
        return [item.label];
    };
    __searchGroups = (items, filter) => {
        return [{
                group: this.dbDef.dbKey, results: items.map(item => ({
                    _id: item._id,
                    uiLabel: item.label
                }))
            }];
    };
}
export const ModuleFE_FHIRQuery = new ModuleFE_FHIRQuery_Class();
//# sourceMappingURL=ModuleFE_FHIRQuery.js.map